import { productImportRuns, products } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectProductSchema = createSelectSchema(products, {
  // Make internal fields optional so they can be filtered out (set to undefined)
  internalPurchasePriceVat0: z.string().nullable().optional(),
  internalSupplierListPriceVat0: z.string().nullable().optional(),
})

export const insertProductSchema = createInsertSchema(products).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export type Product = z.infer<typeof selectProductSchema>
export type CreateProduct = z.infer<typeof insertProductSchema>

// One scheduled or manual run of the supplier catalog import
export const productImportRunSchema = createSelectSchema(productImportRuns, {
  counts: z
    .object({
      inserted: z.number(),
      updated: z.number(),
      deleted: z.number(),
      byChangeType: z.record(z.number()),
    })
    .nullable(),
}).omit({ createdAt: true, updatedAt: true, deletedAt: true })

export type ProductImportRun = z.infer<typeof productImportRunSchema>
